import axios from "axios";
import { getNodeServerUrl } from "@utils/getNodeUrl";

const TEMPLATES_BASE = `${getNodeServerUrl()}/templates`;

/**
 * Fetch the Azure Blob URL for a given template file.
 * @param {string} name - Template file name (e.g. "drm-dealer-list-template.xlsx")
 * @returns {Promise<{ success: boolean, url: string }>}
 */
export const getTemplateUrlApi = (name) =>
  axios.get(TEMPLATES_BASE, { params: { name } });
